/**
 * Donation view configuration
 */
module.config(['$stateProvider', function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('donation', {
            url: '/donation?program', // TODO : translate or not ?
            controller: ['$scope', '$rootScope', '$stateParams', '$state', 'donationsticky', function ($scope, $rootScope, $stateParams, $state, donationsticky) {

                var currentProgram = $stateParams.program || 'selonbesoins';

                $scope.loading = true;

                // Form model
                $scope.donationFormModel = {
                    submitted: false,
                    pending: false,
                    montant: 0,
                    destinations: [
                        { label: 'Patrimoine', id: 'patrimoine', checked: currentProgram === 'patrimoine' },
                        { label: 'Social', id: 'social', checked: currentProgram === 'social' },
                        { label: 'Environnement', id: 'environnement', checked: currentProgram === 'environnement' },
                        { label: 'Selon les besoins', id: 'selonbesoins', checked: currentProgram === 'selonbesoins' }
                    ],
                    paymentOptions: [],
                    montants: []
                };

                // get site config
                var $watcher = $rootScope.$watchCollection('config.site', function (config) {
                    if (config && config.donation) {
                        // config is ready
                        if (!config.donation.don || !config.donation.percent_limit_income || !config.donation.percent_reduction || !config.payment) {
                            // some config are missing
                            $state.go('404');
                        } else {
                            // all needed data are available

                            // get diaporama config
                            if (config.don_slideshow) {
                                $scope.diapoDonation = config.don_slideshow.field_slides;
                                $scope.diapoDonationDelay = config.don_slideshow.field_delay;
                            }

                            // get account config
                            $scope.donationFormModel.montants = config.donation.don;

                            // get percentage values
                            $scope.donationFormModel.limit_income = parseInt(config.donation.percent_limit_income);
                            $scope.donationFormModel.reduction = parseInt(config.donation.percent_reduction);

                            // get payment options
                            $scope.donationFormModel.paymentOptions = [
                                { id: 'card', label: 'Carte bancaire', frequency: 'unique', class: 'aqua-donationform-payment--option-cb', text: config.payment.card.info, enabled: (config.payment.card.enabled === 1) },
                                { id: 'check', label: 'Chèque', frequency: 'unique', class: 'aqua-donationform-payment--option-check', text: config.payment.check.info, enabled: true },
                                { id: 'transfer', label: 'Virement', frequency: 'unique', class: 'aqua-donationform-payment--option-transfer', text: config.payment.transfer.info, enabled: true },
                                { id: 'debit', label: 'Virement mensuel', frequency: 'monthly', text: config.payment.debit.info, enabled: true }
                            ];

                            // set default frequency option
                            $scope.donationFormModel.frequence = 'unique';

                            // get reassurance text
                            if (config.reassurance) {
                                $scope.donationReassurance = config.reassurance;
                            }

                            $scope.loading = false;
                        }
                    }

                });

                donationsticky.disable();

                // destroy watchers
                $scope.$on('$destroy', function () {
                    $watcher();
                    donationsticky.enable();
                });

            }],
            template:
            '<div ng-if="loading" class="grid-main grid grid-v grid-center"><p class="aqua-form--loader grid grid-middle grid-center"><span class="aqua-form--loader-text">Chargement en cours...</span></p></div>' +

            '<div ng-if="!loading">' +
            '  <diaporama ng-if="diapoDonation" diapos="diapoDonation" delay="{{diapoDonationDelay}}" overlay="true"></diaporama>' +

            '  <donationform form-model="donationFormModel"></donationform>' +
            '  <reassurance ng-if="donationReassurance" content="donationReassurance"></reassurance>' +
            '</div>'
        });
}]);
